export const SET_GROUPED_CONTENTS = 'SET_GROUPED_CONTENTS'
export const SET_CONTENTS = 'SET_CONTENTS'
export const SET_MAILING_ID = 'SET_MAILING_ID'
export const SET_FOLDER_ID = 'SET_FOLDER_ID'
export const SET_GROUPBY_TAGS = 'SET_GROUPBY_TAGS'
export const SELECT_TAG = 'SELECT_TAG'
export const SET_TAG_CONTENTS = 'SET_TAG_CONTENTS'
export const SELECT_RECIPIENT = 'SELECT_RECIPIENT'
export const SELECT_CONTENT = 'SELECT_CONTENT'
export const SELECT_ALL_RECIPIENTS = 'SELECT_RECIPIENTS'
export const SELECT_ALL_CONTENTS = 'SELECT_CONTENTS'
export const SET_SELECTED_RECIPIENTS = 'SET_SELECTED_RECIPIENTS'
export const SET_RECIPIENTS = 'SET_RECIPIENTS'
export const SET_PREVIEW_RECIPIENTS = 'SET_PREVIEW_RECIPIENTS'

export const SET_SUBJECT = 'SET_SUBJECT'
export const SET_INTRO_TEXT = 'SET_INTRO_TEXT'
export const SET_STEP_INDEX = 'SET_STEP_INDEX'
export const SET_MODAL_VISIBLE = 'SET_MODAL_VISIBLE'

// mailings
export const SET_MAILINGS = 'SET_MAILINGS'



// WEBPACK FOOTER //
// ./src/store/modules/mailings/types.js